// extracted by mini-css-extract-plugin
export default {"app-layout":"AppLayout_app-layout__R72tj"};